
export enum UserRole {
  EMPLOYER = 'EMPLOYER',
  WORKER = 'WORKER'
}

export enum JobStatus {
  OPEN = 'OPEN',
  FEELER = 'FEELER',
  FILLED = 'FILLED',
  COMPLETED = 'COMPLETED',
  CANCELLED = 'CANCELLED'
}

export enum SkillType {
  Climber = 'Climber',
  Groundsman = 'Groundsman',
  BucketOperator = 'Bucket Operator',
  PHCTechnician = 'PHC Technician',
  CraneOperator = 'Crane Operator',
  StumpGrinder = 'Stump Grinder'
}

export enum VerificationType {
  EMAIL = 'Email',
  PHONE = 'Phone',
  LICENSE = 'License',
  IDENTITY = 'Identity'
}

export interface ForumComment {
  id: string;
  authorId: string;
  authorName: string;
  authorAvatar: string;
  text: string;
  timestamp: string;
}

export interface ForumPost {
  id: string;
  authorId: string;
  authorName: string;
  authorAvatar: string;
  title: string;
  content: string;
  imageUrl?: string;
  likes: string[]; // User IDs
  comments: ForumComment[];
  timestamp: string;
  category: 'EQUIPMENT' | 'SAFETY' | 'BRAGGING_RIGHTS' | 'TECH_TALK' | 'STORM_LOGS';
}

export interface Vouch {
  id: string;
  skill: SkillType;
  vouchedById: string;
  vouchedByName: string;
  comment: string;
  timestamp: string;
}

export interface License {
  id: string;
  type: string;
  number: string;
  expiryDate: string;
  imageUrl: string;
  status: 'PENDING' | 'VERIFIED' | 'REJECTED';
}

export interface Document {
  id: string;
  title: string;
  fileUrl: string;
  uploadDate: string;
  type: 'certification' | 'license' | 'other';
  ownerId?: string;
}

export interface PortfolioProject {
  id: string;
  title: string;
  description: string;
  imageUrl: string;
  date: string;
}

export interface LocalRequirement {
  task: string;
  requirement: string;
  authority: string;
  penalty?: string;
  applyUrl?: string;
}

export interface AvailabilityEvent {
  date: string;
  status: 'BUSY' | 'AVAILABLE';
  title?: string;
}

export interface TeamMember {
  id: string;
  name: string;
  avatar: string;
  skills: SkillType[];
  availability: AvailabilityEvent[];
  assignedJobIds: string[];
}

export interface UserProfile {
  id: string;
  name: string;
  role: UserRole;
  email: string;
  skills: SkillType[];
  certifications: string[];
  licenses: License[];
  portfolio?: PortfolioProject[];
  documents?: Document[];
  verifications: VerificationType[];
  vouches?: Vouch[];
  bio: string;
  rating: number;
  avatar: string;
  banner?: string;
  location?: string;
  following?: string[];
  team?: TeamMember[];
}

export interface Review {
  id: string;
  jobId: string;
  reviewerId: string;
  revieweeId: string;
  rating: number;
  comment: string;
  timestamp: string;
}

export interface Job {
  id: string;
  title: string;
  description: string;
  companyId: string;
  companyName: string;
  date: string;
  location: string;
  payRate: string;
  requiredSkills: SkillType[];
  requiredCerts: string[];
  status: JobStatus;
  applicants: string[]; // User IDs
  workerId?: string; // Assigned worker
  localRequirements?: LocalRequirement[];
  deadline?: string;
}

export interface Message {
  id: string;
  senderId: string;
  text: string;
  timestamp: string;
  type?: 'TEXT' | 'INTERVIEW_PROPOSAL';
  proposalData?: {
    time: string;
    status: 'PENDING' | 'ACCEPTED' | 'REJECTED';
  };
}

export interface Conversation {
  id: string;
  jobId: string;
  workerId: string;
  employerId: string;
  messages: Message[];
  lastMessageAt: string;
}

export interface Application {
  id: string;
  jobId: string;
  workerId: string;
  status: 'PENDING' | 'ACCEPTED' | 'REJECTED';
  appliedAt: string;
  aiMatchScore?: number;
  aiAnalysis?: string;
  interviewTime?: string;
}
